<template>
  <div>
    <!-- Route: {{ parentRoute }} -->
    <validation-observer ref="simpleRules">
      <form-wizard
        ref="wizard"
        color="#7367F0"
        :title="null"
        :subtitle="null"
        layout="vertical"
        :finish-button-text="
          parentRoute ? 'Buchung durchführen' : 'Vertragsvorschau'
        "
        back-button-text="Zurück"
        next-button-text="Weiter"
        class="wizard-vertical mb-3"
        @on-complete="sendFormAction"
      >
        <!-- Select Customer Details -->
        <tab-content
          title="Kundendetails"
          :before-change="() => beforeTabSwitch(1)"
        >
          <move-in-customer-details
            :booking="booking"
            :inquiry-id="inquiryId"
            :parent-route="parentRoute"
            @updateParentRoute="updateParentRouteMethod"
          />
        </tab-content>

        <!-- {{ booking.customer.billingAddressDiffers.orderItem }} -->
        <!-- payment info tab -->
        <tab-content title="Zahlung">
          <move-in-payment-details :booking="booking" />
        </tab-content>
        <!-- Select Storages TAB -->
        <tab-content
          v-if="parentRoute !== 'offer'"
          title="Lager"
        >
          <move-in-storage-selection
            :booking="booking"
            :inquiry="inquiry"
            :parent-route="parentRoute"
          />
        </tab-content>

        <!-- Select Attachment TAB 
        <tab-content title="Dateien">
          
          <move-in-attachment-selection
            ref="myChild"
            :booking="booking"
          />
        </tab-content> -->

        <!-- Make Booking TAB -->
        <tab-content title="Buchung">
          <!-- {{ order }} -->
          <move-in-make-booking
            :booking="booking"
            :parent-route="parentRoute"
          />
        </tab-content>
      </form-wizard>
    </validation-observer>

    <b-modal
      id="modal-booking"
      centered
      ok-only
      ok-title="Accept"
      :hide-footer="true"
      :hide-header="true"
      :hide-header-close="true"
      size="sm"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
      <div class="d-flex justify-content-center mt-1 mb-1">
        <b-spinner label="Loading..." />
      </div>
      <div class="d-flex justify-content-center mb-1">
        {{ spinnerProgressLabel }}
      </div>
    </b-modal>

    <b-modal
      id="modal-booking-danger"
      ok-only
      ok-variant="danger"
      ok-title="Ok"
      modal-class="modal-danger"
      centered
      title="Upps, Fehler :("
    >
      <b-card-text>
        Im Buchungsprozess ist ein Fehler aufgetreten. Bitte versuchen Sie es
        erneut.
      </b-card-text>

      <b-button
        v-b-modal.modal-booking-errorcode
        variant="danger"
      >
        Fehlercode anzeigen!
      </b-button>
    </b-modal>

    <b-modal
      id="modal-booking-errorcode"
      title="Fehlercode"
      scrollable
      size="lg"
      ok-only
      ok-variant="danger"
      ok-title="Ok"
      modal-class="modal-danger"
      centered
    >
      <b-card-text class="my-2">
        {{ errorcode }}
      </b-card-text>
    </b-modal>

    <b-modal
      id="modal-preview"
      scrollable
      title="Vertragsvorschau"
      cancel-title="Abbrechen"
      ok-variant="success"
      ok-title="Buchung durchführen"
      cancel-variant="outline-secondary"
      modal-class="modal-success"
      size="xl"
      @ok="formSubmitted"
    >
      <b-tabs>
        <b-tab
          v-for="(storage, index) in offer.storages"
          :key="index"
          :title="storage.storageIdent"
        >
          <b-card-text>
            <preview-contract-view
              :offer="offer"
              :pdf-storage-print-number="index"
              @contractPDFUpdate="updateContractArray"
            />
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-modal>

    <!-- Booking Confirmation Dialog -->
    <booking-confirmation-modal
      :booking="booking"
      :validation-result="currentValidationResult"
      :parent-route="parentRoute"
      @booking-confirmed="onBookingConfirmed"
    />
  </div>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import emailjs from '@emailjs/browser'
import { required } from '@validations'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import { German } from 'flatpickr/dist/l10n/de'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Vueflatpickr from 'vue-flatpickr-component'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import vSelect from 'vue-select'
// eslint-disable-next-line no-unused-vars
import axios from 'axios'

import {
  BButton,
  BCardText,
  BModal,
  BSpinner,
  BTab,
  BTabs,
  VBModal,
} from 'bootstrap-vue'

import emailStoragesBody from '@/helper/emailStoragesBody'
import helper from '@/helper/helper'
import sendEmail from '@/service/emailService'
import StorageAvailabilityService from '@/service/storageAvailability'
import Offer from '@/store/offer/Offer'
import VueHtml2pdf from 'vue-html2pdf'
import BookingConfirmationModal from '@/components/booking/BookingConfirmationModal.vue'
import bookingSummery from './BookingSummery.vue'
import ContractLagermeister from './ContractLagermeister.vue'
import MoveInAttachmentSelection from './MoveInAttachmentSelection.vue'
import MoveInCustomerDetails from './MoveInCustomerDetails.vue'
import MoveInMakeBooking from './MoveInMakeBooking.vue'
import MoveInPaymentDetails from './MoveInPaymentDetails.vue'
import MoveInStorageSelection from './MoveInStorageSelection.vue'
import PreviewContractView from './PreviewContractView.vue'

flatpickr.localize(German)

export default {
  setup() {
    const { getFormattedDate, getCountryOptions, getSalutionOptions } = helper()

    return { getFormattedDate, getCountryOptions, getSalutionOptions }
  },

  components: {
    BTabs,
    BCardText,
    BTab,
    MoveInCustomerDetails,
    MoveInPaymentDetails,
    MoveInStorageSelection,
    MoveInAttachmentSelection,
    MoveInMakeBooking,
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BButton,
    vSelect,
    BSpinner,
    flatpickr: Vueflatpickr,
    BModal,
    emailjs,
    bookingSummery,
    VueHtml2pdf,
    Offer,
    ToastificationContent,
    ContractLagermeister,
    PreviewContractView,
    emailStoragesBody,
    BookingConfirmationModal,
  },

  directives: {
    'b-modal': VBModal,
  },

  props: {
    inquiryId: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    // Generate session ID for tracking
    const sessionId = Math.random().toString(36).substring(2) + Date.now().toString(36)

    return {
      parentRoute: this.$route.params.parentRoute,
      offer: Offer,
      booking: {
        sessionId,
        startTime: new Date().toISOString(),
        customer: this.$route.params.booking
          ? this.$route.params.booking
          : { billingAddressDiffers: false },
        order: {
          orderDate: null,
          orderDetails: null,
          order_items: [],
          customer: null,
          created_by: null,
          updated_by: null,
          customerSignature: null,
          emailStatus: null, // Track email sending status
        },
        uplAttachment: [],
        selectedStorages: this.$route.params.storages
          ? this.$route.params.storages
          : [],
        isExistingCustomer: false,
        bookingDate: null,
        invoiceNumber: null,
        customerSignatureImage: null,
        landlordSignatureImage: null,
        contractArray: [],
        generateContract: true,
      },
      inquiry: null,
      pdfBookingFile: null,
      pdfStoragePrintNumber: 0,
      spinnerProgressLabel: '',
      required,
      // countryOptions: ['Deutschland', 'Schweiz', 'Österreich'],
      selectedPaymentType: { orderItem: 'lastschrift', text: 'Lastschrift' },
      selectedStorageLocation: 'Standort auswählen...',
      billingadressItems: [
        { orderItem: 'false', text: 'Identisch mit Kundenadresse' },
        { orderItem: 'true', text: 'NICHT Identisch mit Kundenadresse' },
      ],
      paymentTypeItems: [
        { orderItem: 'lastschrift', text: 'Lastschrift' },
        { orderItem: 'kreditkarte', text: 'Kreditkarte' },
      ],
      errorcode: '',
      emailAttachments: [],
      currentValidationResult: {
        valid: false,
        conflicts: [],
        availableStorages: [],
        summary: ''
      },
    }
  },
  computed: {
    //   parentName() {
    //   return this.$parent.$options.name
    // }
  },

  created() {
    // If coming from offer, ensure mobile number is properly extracted
    if (this.$route.params.booking && this.parentRoute === 'offer') {
      this.extractMobileNumberFromOffer()
    }

    // Log booking session start
    this.logBookingTransaction('BOOKING_STARTED', {
      parentRoute: this.parentRoute,
      inquiryId: this.inquiryId,
      hasExistingCustomer: !!this.$route.params.booking,
      hasPreselectedStorages: !!this.$route.params.storages
    })
  },

  methods: {
    extractMobileNumberFromOffer() {
      const offer = this.$route.params.booking
      if (!offer) return

      // Apply same logic as OffersViewInfoCards.vue displayMobileNumber computed property
      let mobileNumber = null

      // First, try the offer's mobile number directly
      if (offer.mobileNumber) {
        mobileNumber = offer.mobileNumber
      } else if (offer.inquiry && offer.inquiry.mobileNumber) {
        // If offer doesn't have mobile, check inquiry directly
        mobileNumber = offer.inquiry.mobileNumber
      }

      // Update booking.customer.mobileNumber if we found one
      if (mobileNumber && this.booking.customer) {
        this.booking.customer.mobileNumber = mobileNumber
      }
    },

    updateParentRouteMethod(newRoute) {
      this.parentRoute = newRoute
    },

    async sendFormAction() {
      console.log(
        '🚀 ~ file: Movein.vue:307 ~ sendFormAction ~ this.parentRoute:',
        this.parentRoute
      )
      if (
        /* eslint-disable operator-linebreak */
        this.parentRoute === 'offer' ||
        this.parentRoute === 'addExistingOrder'
      ) {
        // Show confirmation dialog with storage availability validation
        await this.showBookingConfirmationWithValidation()
      } else {
        this.showBookingPreview()
      }
    },

    async showBookingConfirmationWithValidation() {
      // Validate that storages are selected
      if (!this.booking.selectedStorages || this.booking.selectedStorages.length === 0) {
        this.$toast.error('Bitte wählen Sie mindestens eine Lagereinheit aus')
        return
      }

      // Get storage IDs for validation
      const storageIds = this.booking.selectedStorages.map(storage =>
        (typeof storage === 'object' ? storage.id : storage))

      // Get offer ID if coming from offer
      const offerId = this.parentRoute === 'offer' && this.$route.params.booking
        ? this.$route.params.booking.id
        : null

      // Validate storage availability
      this.currentValidationResult = await StorageAvailabilityService.validateStoragesForBooking(storageIds, offerId)

      // Show the booking confirmation modal
      this.$bvModal.show('modal-booking-confirmation')
    },

    onBookingConfirmed(data) {
      // Log booking confirmation
      const storageIds = this.booking.selectedStorages.map(storage =>
        (typeof storage === 'object' ? storage.id : storage))

      if (!data.validationResult.valid) {
        // Log forced booking with conflicts
        this.logBookingTransaction('BOOKING_FORCED_WITH_CONFLICTS', {
          conflicts: data.validationResult.conflicts,
          storageIds,
          mailServiceStatus: data.mailServiceStatus
        })
      }

      // Log successful validation and proceed
      this.logBookingTransaction('BOOKING_VALIDATED', {
        storageIds,
        validationResult: data.validationResult.summary,
        hasConflicts: !data.validationResult.valid,
        mailServiceStatus: data.mailServiceStatus
      })

      // Hide the modal and proceed with booking
      this.$bvModal.hide('modal-booking-confirmation')

      // Skip contract preview for offers since contracts are in Zoho
      if (this.parentRoute === 'offer') {
        this.formSubmitted()
      } else {
        this.showBookingPreview()
      }
    },

    // NEW: Show booking confirmation dialog with validation
    async showBookingConfirmation() {
      console.log('🚀 ~ showBookingConfirmation ~ selectedStorages:', this.booking.selectedStorages)

      // Validate that storages are selected
      if (!this.booking.selectedStorages || this.booking.selectedStorages.length === 0) {
        this.$toast.error('Bitte wählen Sie mindestens eine Lagereinheit aus')
        return
      }

      // Show the confirmation dialog
      this.$bvModal.show('modal-booking-confirmation')
    },

    updateContractArray(pdf) {
      console.log('updateContractArray')
      this.booking.contractArray.push(pdf)
      console.log(this.booking.contractArray)
    },

    offerMapping() {
      this.offer.firstName = this.booking.customer.firstName
      this.offer.lastName = this.booking.customer.lastName
      this.offer.email = this.booking.customer.email
      this.offer.salutation = this.booking.customer.salutation
      this.offer.street = this.booking.customer.street
      this.offer.streetNumber = this.booking.customer.streetNumber
      this.offer.zipCode = this.booking.customer.zipCode
      this.offer.city = this.booking.customer.city
      this.offer.country = this.booking.customer.country
      this.offer.phoneNumber = this.booking.customer.phoneNumber
      this.offer.mobileNumber = this.booking.customer.mobileNumber
      this.offer.company = this.booking.customer.company
      this.offer.offerDate = Date.now()
      this.offer.storages = this.booking.selectedStorages
      this.offer.inquiry = this.booking.customer.id
      this.offer.customerSignatureImage = this.booking.customerSignatureImage
      this.offer.landlordSignatureImage = this.booking.landlordSignatureImage
      this.offer.isActive = true
    },

    showBookingPreview() {
      // empty this.booking.contractArray
      this.booking.contractArray = []

      this.offerMapping()
      this.$bvModal.show('modal-preview')
    },

    // ############################# PDF #############################
    generateBookingPDF() {
      this.offerMapping()
      this.$refs.html2Pdf.generatePdf()
    },

    generateBookingPDFButton() {
      // lop throug selectedStorages and create a pdf for each storage

      this.offerMapping()
      this.$refs.html2Pdf.generatePdf()

      this.booking.storages.forEach((storage, i) => {
        this.pdfStoragePrintNumber = i
        this.$refs.html2Pdf.generatePdf()
      })
    },

    saveContractPDF(pdf) {
      // alert('Dialog OK')

      const formData = new FormData()
      formData.append('files', pdf)

      const config = {
        onUploadProgress: uploadEvent => {
          console.log(
            `Upload Progress: ${Math.round(
              (uploadEvent.loaded / uploadEvent.total) * 100
            )} %`
          )
        },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }

      this.$store
        .dispatch('addFile', formData, config)
        .then(respond => {
          const attachmentWithFiles = {
            note: 'Vertragsunterlagen',
            customer: respond.id,
            attachment_type: 3,
            created_by: 'EK',
            updated_by: 'EK',
            files: respond.map(a => a.id),
          }

          this.$store
            .dispatch('addAttachment', attachmentWithFiles)
            .then(() => {
              // this.$router.go()
            })
        })
        .catch(() => {})
    },

    beforeTabSwitch() {
      return this.$refs.simpleRules.validate().then(success => {
        if (success) {
          return true
        }
        return true
      })
    },

    // ############################# Booking Form  #############################
    formSubmitted() {
      console.log('🚀 ~ file: Movein.vue:420 ~ formSubmitted:')
      this.spinnerProgressLabel = 'Fange mit der Magie an...'
      this.$bvModal.show('modal-booking')

      //* * OrderItems Array */
      const resultOrderItems = []

      // eslint-disable-next-line operator-linebreak
      this.booking.isExistingCustomer =
        this.$store.getters.customerExistByEmail(this.booking.customer.email)
      console.log(
        '🚀 ~ file: Movein.vue:429 ~ formSubmitted ~ this.booking:',
        this.booking
      )

      //* * Create the order_items */
      // eslint-disable-next-line no-plusplus
      for (
        let index = 0;
        index < this.booking.selectedStorages.length;
        index += 1
      ) {
        this.spinnerProgressLabel = `Erstelle Position ${index + 1}`

        // Storage holen und Reservierung zurücksetzen
        const storage = this.booking.selectedStorages[index]
        storage.storageReservation = false

        // Storage im Backend aktualisieren
        this.$store
          .dispatch('updateStorage', storage)
          .then(result => {
            console.log(`Storage ${storage.id} Reservierung zurückgesetzt:`, result)
          })
          .catch(error => {
            console.error(`Fehler beim Update von Storage ${storage.id}:`, error)
          })

        //* * OrderItem */
        const orderItem = {
          price: storage.price,
          discount: storage.discount,
          ItemDetails: null,
          rentStart: storage.rentStart,
          rentEnd: storage.rentEnd
            ? storage.rentEnd
            : '2099-12-31T23:00:00.000Z',
          storage: storage.id,
          order: null,
          created_by: null,
          updated_by: null,
        }
        console.log(
          '🚀 ~ file: Movein.vue:456 ~ formSubmitted ~ orderItem:',
          orderItem
        )

        //* * Create orderItems */
        this.$store
          .dispatch('addOrderItem', orderItem)
          .then(result => {
            resultOrderItems.push(result)
            console.log(`resultOrderItems ${JSON.stringify(resultOrderItems)}`)
          })
          .catch(error => {
            this.failureNextSteps(error)
          })
      }

      console.log(
        '🚀 ~ file: Movein.vue:472 ~ formSubmitted ~ this.booking:',
        this.booking
      )

      //* * Existing customer */
      if (this.booking.isExistingCustomer) {
        console.log(
          '🚀 ~ file: Movein.vue:480 ~ formSubmitted ~ this.booking.customer:',
          this.booking.isExistingCustomer
        )
        this.spinnerProgressLabel = 'Aktualisiere Kunde...'
        this.$store
          .dispatch('updateCustomer', this.booking.isExistingCustomer)

          .then(result => {
            //* * Order */
            this.createOrder(result, resultOrderItems)

            //* * Create Order */
            // this.createOrderWithOrderItems(resultOrderItems)

            //* * Create Attachments */
            this.createAttachments(result)
          })
          .catch(error => {
            this.failureNextSteps(error, 'updateCustomer')
          })
      } else {
        //* * Create the customer */
        console.log(
          '🚀 ~ file: Movein.vue:499 ~ formSubmitted ~ Create Customer:'
        )
        this.spinnerProgressLabel = 'Erstelle Kunde...'
        this.$store
          .dispatch('addCustomer', this.booking.customer)
          .then(result => {
            console.log(`result ${JSON.stringify(result)}`)
            //* * Order */
            this.createOrder(result, resultOrderItems)

            //* * Create Attachments */
            this.createAttachments(result)

            console.log(result)
          })
          .catch(error => {
            this.failureNextSteps(error, 'addCustomer')
          })
      }
    },

    //* * Upload Attachments */
    createAttachments(result) {
      console.log(
        '🚀 ~ file: Movein.vue:524 ~ createAttachments ~ result:',
        result
      )
      this.spinnerProgressLabel = 'Lade Anlagen hoch...'

      const config = {
        onUploadProgress: uploadEvent => {
          console.log(
            `Upload Progress: ${Math.round(
              (uploadEvent.loaded / uploadEvent.total) * 100
            )} %`
          )
        },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }

      this.booking.contractArray.forEach(contractItem => {
        const formData = new FormData()
        formData.append('files', contractItem, 'Vertragsunterlagen.pdf')

        // contractItem.files.forEach(fileItem => {
        //   const file = fileItem
        //   formData.append('files', file)
        // })

        this.$store
          .dispatch('addFile', formData, config)
          .then(respond => {
            console.log(`AddFile Respond: ${JSON.stringify(respond)}`)
            const attachmentWithFiles = {
              note: 'Vertragsunterlagen',
              customer: result.id,
              attachment_type: 2,
              created_by: 'System',
              updated_by: 'System',
              files: respond.map(a => a.id),
            }
            console.log(
              `AttachmentWithFiles: ${JSON.stringify(attachmentWithFiles)}`
            )

            this.$store
              .dispatch('addAttachment', attachmentWithFiles)
              .then(() => {
                // this.$router.go()
              })
          })
          .catch(error => {
            console.log('Error: addFile')
            console.log(error)
            return error
          })
      })

      this.booking.uplAttachment
        .filter(attachmentItem => attachmentItem.files.length > 0)
        .forEach(attachmentItem => {
          // if (attachmentItem.files.length === 0) { return }

          const formData = new FormData()

          attachmentItem.files.forEach(fileItem => {
            const file = fileItem
            formData.append('files', file)
          })

          this.$store
            .dispatch('addFile', formData, config)
            .then(respond => {
              console.log(`AddFile Respond: ${JSON.stringify(respond)}`)
              const attachmentWithFiles = {
                note: attachmentItem.note,
                customer: result.id,
                attachment_type: attachmentItem.id,
                created_by: 'EK',
                updated_by: 'EK',
                files: respond.map(a => a.id),
              }
              console.log(
                `AttachmentWithFiles: ${JSON.stringify(attachmentWithFiles)}`
              )

              this.$store
                .dispatch('addAttachment', attachmentWithFiles)
                .then(() => {
                  // this.$router.go()
                })
            })
            .catch(error => {
              this.failureNextSteps(error, 'add File')
            })
        })

      // update existing attachments on customer with updateAttachment
      this.booking.customer.attachments.forEach(attachmentItem => {
        this.$store
          .dispatch('updateAttachment', attachmentItem)
          .then(() => {
            console.log('Update Attachment')
            // this.$router.go()
          })
          .catch(error => {
            this.failureNextSteps(error, 'updateAttachment')
          })
      })
    },

    createOrder(result, resultOrderItems) {
      console.log(
        '🚀 ~ file: Movein.vue:618 ~ createOrder ~ resultOrderItems:',
        resultOrderItems
      )
      this.booking.order.orderDate = Date.now()
      this.booking.order.order_items = resultOrderItems
      this.booking.order.customer = result.id
      this.booking.order.created_by = 'EK'
      this.booking.order.updated_by = 'EK'

      // Add offer relationship if coming from an offer
      if (this.parentRoute === 'offer' && this.$route.params.booking?.id) {
        this.booking.order.offer = this.$route.params.booking.id
        console.log('Setting offer relationship:', this.$route.params.booking.id)

        // Also update the offer with customer relationship if not set
        const offerId = this.$route.params.booking.id
        const offer = this.$store.getters.offerByID(offerId)

        if (offer && !offer.customer) {
          this.$store.dispatch('updateOffer', {
            id: offerId,
            customer: result.id
          }).then(() => {
            console.log('Updated offer with customer relationship:', result.id)
          }).catch(error => {
            console.error('Error updating offer with customer:', error)
          })
        }
      }

      // Upload CustomerSignature
      //
      if (
        /* eslint-disable operator-linebreak */
        !this.parentRoute
      ) {
        console.log('Upload Customer Signature')

        this.uploadCustomerSignature(resultOrderItems)
      } else {
        console.log('Create Order with OrderItems')
        this.createOrderWithOrderItems(resultOrderItems)
      }
    },

    uploadCustomerSignature(resultOrderItems) {
      console.log(
        '🚀 ~ file: Movein.vue:634 ~ uploadCustomerSignature ~ resultOrderItems:',
        resultOrderItems
      )
      const config = {
        onUploadProgress: uploadEvent => {
          console.log(
            `Upload Progress: ${Math.round(
              (uploadEvent.loaded / uploadEvent.total) * 100
            )} %`
          )
        },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }

      const formData = new FormData()

      const signatureName = `Signature_${this.booking.customer.lastName}_${this.booking.customer.firstName}.png`

      formData.append(
        'files',
        this.booking.order.customerSignature,
        signatureName
      )
      this.$store
        .dispatch('addFile', formData, config)
        .then(respond => {
          this.booking.order.customerSignature = respond.map(a => a.id)

          this.createOrderWithOrderItems(resultOrderItems)
        })
        .catch(error => {
          this.failureNextSteps(error, 'Upload Signature')
        })
    },

    createOrderWithOrderItems(resultOrderItems) {
      console.log(
        '🚀 ~ file: Movein.vue:669 ~ createOrderWithOrderItems ~ resultOrderItems:',
        resultOrderItems
      )

      this.spinnerProgressLabel = 'Erstelle Buchungseintrag...'

      //* * Create Order */

      console.log(
        '🚀 ~ file: Movein.vue:676 ~ createOrderWithOrderItems ~ this.booking.order:',
        this.booking.order
      )

      this.$store
        .dispatch('addOrder', this.booking.order)
        .then(resultOrder => {
          const orderItems = JSON.parse(JSON.stringify(resultOrderItems))
          console.log(
            '🚀 ~ file: Movein.vue:694 ~ createOrderWithOrderItems ~ orderItems:',
            orderItems
          )
          console.log(
            '🚀 ~ file: Movein.vue:694 ~ createOrderWithOrderItems ~ resultOrder:',
            resultOrder
          )

          this.booking.invoiceNumber = resultOrder.id

          orderItems.forEach(oItem => {
            // eslint-disable-next-line no-param-reassign
            oItem.order = resultOrder.id
          })

          // eslint-disable-next-line no-plusplus
          for (let index = 0; index < orderItems.length; index++) {
            //* * Update orderItems */
            this.$store
              .dispatch('updateOrderItem', orderItems[index])
              .catch(error => {
                this.failureNextSteps(error, 'updateOrderItem')
              })
          }

          // TODO: Optimze the Paramaters
          this.successNextSteps(resultOrder, orderItems)
        })
        .catch(error => {
          this.failureNextSteps(error, 'addOrder')
        })
    },
    // eslint-disable-next-line no-unused-vars
    async successNextSteps(resultOrder, orderItems) {
      console.log('Booking completed successfully:', resultOrder)

      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Buchung erfolgreich erstellt!',
          text: `Buchung #${resultOrder.id} wurde erfolgreich angelegt`,
          icon: 'CheckCircleIcon',
          variant: 'success',
        },
      })

      // Log booking completion
      this.logBookingTransaction('BOOKING_COMPLETED', {
        orderId: resultOrder.id,
        customerEmail: this.booking.customer.email,
        storageCount: orderItems.length,
        totalValue: orderItems.reduce((sum, item) => sum + (item.price || 0), 0)
      })

      // NEW: Update offer status if booking was made from an offer
      await this.updateOfferStatusAfterBooking(resultOrder)

      // Send email if not adding to existing order
      if (this.parentRoute !== 'addExistingOrder') {
        console.log('Sending booking confirmation email')
        await this.onSendEmail(orderItems, resultOrder)
      }

      this.$bvModal.hide('modal-booking')

      // Enhanced success flow with navigation
      this.showBookingSuccess(resultOrder)
    },

    showBookingSuccess(order) {
      // Show detailed success information
      this.$bvModal.msgBoxOk(
        `Ihre Buchung wurde erfolgreich erstellt!\n\nBuchungs-Nr.: #${order.id}\nKunde: ${this.booking.customer.firstName} ${this.booking.customer.lastName}\nEmail: ${this.booking.customer.email}\n\nSie können die Buchungsdetails jetzt einsehen oder weitere Buchungen vornehmen.`,
        {
          title: 'Buchung erfolgreich!',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
        }
      ).then(async () => {
        // Refresh order and order items stores to ensure new data is available for the view
        console.log('Refreshing order and order items stores before navigation')
        await Promise.all([
          this.$store.dispatch('getOrderEntries'),
          this.$store.dispatch('getOrderItemsEntries')
        ])

        // Navigate to order details
        this.$router.push(`/orders-view/${order.id}`)
      })
    },

    logBookingTransaction(event, data = {}) {
      const logEntry = {
        timestamp: new Date().toISOString(),
        event,
        sessionId: this.booking.sessionId || 'unknown',
        data,
        userAgent: navigator.userAgent,
        url: window.location.href
      }

      console.log('Booking Transaction Log:', logEntry)

      // Store in localStorage for debugging and future analytics
      try {
        const existingLogs = JSON.parse(localStorage.getItem('bookingLogs') || '[]')
        existingLogs.push(logEntry)

        // Keep only last 50 entries
        if (existingLogs.length > 50) {
          existingLogs.splice(0, existingLogs.length - 50)
        }

        localStorage.setItem('bookingLogs', JSON.stringify(existingLogs))
      } catch (error) {
        console.error('Failed to store booking log:', error)
      }
    },
    failureNextSteps(error, description) {
      console.error(`Booking Error in ${description}:`, error)

      // Log booking failure
      this.logBookingTransaction('BOOKING_FAILED', {
        step: description,
        error: error.message || 'Unknown error',
        customerEmail: this.booking.customer?.email,
        errorDetails: error
      })

      // Enhanced error display
      this.errorcode = JSON.stringify(error, null, 2)

      // Show user-friendly error message
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Buchung fehlgeschlagen',
          text: `Fehler bei: ${description}. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.`,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })

      this.$bvModal.show('modal-booking-danger')
    },

    async onSendEmail(orderItems, order) {
      const emailType = 'booking'
      console.log(
        '🚀 ~ file: Movein.vue:708 ~ onSendEmail ~ emailType:',
        emailType
      )

      try {
        this.spinnerProgressLabel = 'Versende Buchungsbestätigung...'

        const emailBody = emailStoragesBody(orderItems, emailType)

        const email = {
          to: this.booking.customer.email,
          subject: 'Der Lagermeister - Buchungsbestätigung',
          text: emailBody,
          attachments: this.booking.contractArray,
          template_id: 'd-8b14bf5786944de1b354018d51e9a397',
          dynamic_template_data: {
            salutation: this.booking.customer.salutation,
            lastName: this.booking.customer.lastName,
            mobileNumber: this.booking.customer.mobileNumber,
            orderDate: this.getFormattedDate(this.booking.orderDate),
            orderID: order.id,
            orderItems: emailBody,
          },
        }

        const result = await sendEmail(email, {
          maxRetries: 3,
          timeout: 30000,
          enableRetry: true
        })

        if (result.success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Email erfolgreich versendet!',
              text: `Buchungsbestätigung wurde an ${this.booking.customer.email} gesendet`,
              icon: 'MailIcon',
              variant: 'success',
            },
          })

          // Store email status in order metadata for future reference
          if (result.data?.requestId) {
            this.booking.order.emailStatus = {
              sent: true,
              requestId: result.data.requestId,
              messageId: result.data.messageId,
              sentAt: result.data.timestamp,
              recipient: this.booking.customer.email
            }
          }

          console.log('Email sent successfully:', result.data)
        } else {
          this.handleEmailError(result.error)
        }
      } catch (error) {
        console.error('Unexpected error in email sending:', error)
        this.handleEmailError({
          type: 'UNEXPECTED_ERROR',
          message: 'Ein unerwarteter Fehler ist aufgetreten',
          duration: 0
        })
      }
    },

    handleEmailError(error) {
      console.error('Email sending failed:', error)

      let errorTitle = 'Email-Versand fehlgeschlagen'
      let errorMessage = error.message || 'Unbekannter Fehler beim Versenden der Email'
      const variant = 'danger'
      const icon = 'AlertTriangleIcon'

      // Customize error message based on error type
      switch (error.type) {
        case 'VALIDATION_ERROR':
          errorTitle = 'Ungültige Email-Daten'
          errorMessage = 'Bitte überprüfen Sie die Email-Adresse und versuchen Sie es erneut'
          break
        case 'NETWORK_ERROR':
          errorTitle = 'Netzwerkfehler'
          errorMessage = 'Keine Verbindung zum Email-Service. Bitte versuchen Sie es später erneut'
          break
        case 'TIMEOUT_ERROR':
          errorTitle = 'Zeitüberschreitung'
          errorMessage = 'Email-Versand dauerte zu lange. Bitte versuchen Sie es erneut'
          break
        case 'ATTACHMENT_ERROR':
          errorTitle = 'Anhang-Fehler'
          errorMessage = 'Problem mit den Datei-Anhängen. Bitte überprüfen Sie die Dateien'
          break
        case 'RETRY_EXHAUSTED':
          errorTitle = 'Wiederholte Versuche fehlgeschlagen'
          errorMessage = 'Email konnte nach mehreren Versuchen nicht versendet werden'
          break
        default:
          // Keep default error message and title
          break
      }

      this.$toast({
        component: ToastificationContent,
        props: {
          title: errorTitle,
          text: errorMessage,
          icon,
          variant,
        },
      })

      // Store failed email status
      this.booking.order.emailStatus = {
        sent: false,
        error: error.type || 'UNKNOWN_ERROR',
        errorMessage,
        failedAt: new Date().toISOString(),
        recipient: this.booking.customer.email
      }
    },

    sendEmail(orderItems) {
      // (C) CREATE HTML TABLE
      // (C1) HTML TABLE STRING
      // eslint-disable-next-line operator-linebreak
      let myTable =
        '<head><style>table, th, td {border: 0px solid black;border-collapse: collapse;}th {text-align: left;}</style></head><table style="width: 100%;"><tr style="text-align: left;"><th>Name</th><th>ID</th><th>Stadt</th><th>Strasse</th><th>Mietbeginn</th><th>Mietende</th><th>Preis/Monat</th></tr><tr>'
      // (C2) LOOP THROUGH ARRAY & GENERATE ROWS-CELLS
      const perrow = 7 // 2 CELLS PER ROW
      orderItems.forEach((orderItem, i) => {
        // "NORMAL" CELL

        const location = this.$store.getters.locationById(
          Number(orderItem.storage.location)
        )

        myTable += `<td>${orderItem.storage.name}</td>`
        myTable += `<td>${orderItem.storage.storageIdent}</td>`
        myTable += `<td>${location.city}</td>`
        myTable += `<td>${location.street} ${location.streetNumber}</td>`
        myTable += `<td>${this.getFormattedDate(orderItem.rentStart)}</td>`
        myTable += `<td>${orderItem.rentEnd ? this.getFormattedDate(orderItem.rentEnd) : 'Unbefristet'}</td>`
        myTable += `<td>${orderItem.price} €</td>`

        // BREAK INTO NEXT ROW
        const next = i + 1
        if (next % perrow === 0 && next !== orderItems) {
          myTable += '</tr><tr>'
        }
      })

      // (C3) CLOSE TABLE
      myTable += '</tr></table>'

      return myTable
    },

    // NEW: Update offer status after successful booking
    async updateOfferStatusAfterBooking(resultOrder) {
      // Only update offer if booking was made from an offer
      if (this.parentRoute !== 'offer' || !this.$route.params.booking?.id) {
        return
      }

      const offerId = this.$route.params.booking.id

      try {
        // Get current offer data
        const offer = this.$store.getters.offerByID(Number(offerId))

        if (!offer) {
          return
        }

        // Update offer with proper completion fields
        const updatedOffer = {
          id: offerId,
          isActive: false, // Mark offer as no longer active
          bookingCompleted: true, // Mark as converted to booking
          completionDate: new Date().toISOString(), // Record completion time
          order: resultOrder.id // Reference to the created order
        }

        // Update offer in store
        await this.$store.dispatch('updateOffer', updatedOffer)

        // Log the offer update
        this.logBookingTransaction('OFFER_COMPLETED', {
          offerId,
          orderId: resultOrder.id,
          completionDate: updatedOffer.completionDate
        })

        // Show additional success message
        this.$toast.success(`Angebot #${offerId} wurde als abgeschlossen markiert`)
      } catch (error) {
        console.error('Error updating offer status:', error)
        this.$toast.error('Fehler beim Aktualisieren des Angebotsstatus')

        // Log the error but don't fail the booking
        this.logBookingTransaction('OFFER_UPDATE_ERROR', {
          offerId,
          orderId: resultOrder.id,
          error: error.message
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

hr.style1 {
  border-top: 1px solid #8c8b8b;
}
hr.style5 {
  background-color: #fff;
  border-top: 2px dashed #8c8b8b;
}
</style>
